<template>

  <div class="py-4 container-fluid remissions-create-page">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="mb-0 me-auto">{{ pageTitle }}</p>
              <button
                v-if="form.id != 0"
                type="button"
                class="btn btn-outline-secondary btn-sm mb-0"
                title="Compartir enlace público del PDF"
                @click="sharePublicPdf"
              >
                <i class="fas fa-share-alt"></i>
              </button>
              <button
                v-if="form.id != 0"
                type="button"
                class="btn btn-outline-primary btn-sm mb-0"
                @click="generatePdf"
              >
                <i class="fa fa-file-pdf me-1"></i> Generar PDF
              </button>
              <argon-button v-if="form.status != 1 && ((user.role !== '1' && form.status == 0) || user.role === '1')" color="success"
                size="sm" @click="save">Guardar</argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Cliente</label>
                <div class="d-flex gap-2">
                  <select
                    ref="clientSelect"
                    class="form-select flex-grow-1"
                    v-model="form.cliente_id"
                    @change="selectClient"
                    :disabled="form.status == 1"
                  >
                    <option value="">Seleccione un cliente</option>
                    <option v-for="client in clients" :key="client.id" :value="client.id">
                      {{ client.name }} - {{ client.document }}
                    </option>
                  </select>
                  <argon-button
                    v-if="form.status != 1"
                    color="success"
                    size="sm"
                    @click="openAddClientModal"
                    title="Agregar cliente"
                  >
                    <i class="fas fa-user-plus"></i>
                  </argon-button>
                </div>
              </div>
              <div v-if="isQuoteMode" class="col-md-12">
                <label class="form-control-label">Orden de servicio <span class="text-muted fw-normal">(opcional)</span></label>
                <select
                  ref="serviceOrderSelect"
                  class="form-select"
                  :disabled="form.status == 1 || !form.cliente_id"
                >
                  <option value=""></option>
                  <option
                    v-for="order in serviceOrders"
                    :key="order.id"
                    :value="order.id"
                  >
                    {{ formatServiceOrderLabel(order) }}
                  </option>
                </select>
                <small v-if="!form.cliente_id" class="text-muted">Seleccione un cliente para ver sus órdenes de servicio.</small>
              </div>
              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observación</label>
                <ArgonTextarea type="text" v-model="form.observation" :disabled="form.status == 1" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Fotos de pagos</p>
              <button
                v-if="form.id != 0"
                type="button"
                class="btn btn-sm btn-outline-primary ms-auto mb-0"
                @click="$refs.paymentPhotoInput.click()"
                :disabled="uploadingPaymentPhoto"
              >
                <i class="fa fa-camera me-1"></i>
                {{ uploadingPaymentPhoto ? 'Subiendo...' : 'Adjuntar' }}
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="border rounded p-3">
              <div v-if="paymentPhotos.length" class="row g-2">
                <div
                  v-for="photo in paymentPhotos"
                  :key="photo.id"
                  class="col-6 d-flex justify-content-center"
                >
                  <div class="payment-photo-card position-relative">
                    <img
                      :src="apiUrl + photo.file_path"
                      alt="Comprobante de pago"
                      class="payment-photo-thumb"
                      title="Ver imagen"
                      @click="openPaymentPhoto(photo)"
                    />
                    <button
                      v-if="form.status != 1"
                      type="button"
                      class="payment-photo-remove-btn"
                      @click="removePaymentPhoto(photo.id)"
                      title="Eliminar foto"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-else class="text-center text-muted text-sm py-3">
                {{ form.id != 0 ? 'No hay fotos de pagos adjuntas.' : 'Guarde la venta para adjuntar fotos.' }}
              </div>
              <input
                ref="paymentPhotoInput"
                type="file"
                accept="image/*"
                multiple
                class="d-none"
                @change="onPaymentPhotoChange"
              />
            </div>
          </div>
        </div>

        <div v-if="isQuoteMode && selectedServiceOrder" class="card mt-3">
          <div class="card-header pb-0">
            <p class="mb-0 text-sm">Orden de servicio #{{ String(selectedServiceOrder.id).padStart(4, '0') }}</p>
          </div>
          <div class="card-body">
            <p class="text-xs text-secondary mb-2">
              {{ formatServiceOrderLabel(selectedServiceOrder) }}
            </p>
            <div class="service-order-description">
              <p class="text-uppercase text-xs text-secondary mb-2">Descripción / observaciones</p>
              <p class="text-sm mb-0 text-dark" style="white-space: pre-wrap;">
                {{ selectedServiceOrder.observations || 'Sin descripción registrada.' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-10">
        <div class="card" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Lista de detalles</p>
              <argon-button
                v-if="form.status != 1 && ((user.role !== '1' && form.status === 0) || user.role === '1')"
                color="success"
                size="sm"
                class="ms-auto"
                @click="addDetail"
              >
                Agregar producto
              </argon-button>
            </div>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                        v-if="form.status != 1 && ((user.role !== '1' && form.status === 0) || user.role === '1')"
                      >
                        Opciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="detailsList.length === 0">
                      <td :colspan="detailsTableColspan" class="text-center text-sm text-secondary py-4">
                        No hay productos agregados. Use «Agregar producto».
                      </td>
                    </tr>
                    <tr v-for="value in detailsList" :key="value.id">
                      <td class="align-middle">
                        <h6
                          class="mb-0 text-sm detail-product-label"
                          :title="formatDetailProductLabel(value)"
                        >
                          {{ formatDetailProductLabel(value) }}
                        </h6>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ value.quantity }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.price ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">
                          {{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) }}
                        </span>
                      </td>

                      <td
                        v-if="form.status != 1 && ((user.role !== '1' && form.status === 0) || user.role === '1')"
                        class="align-middle text-center"
                      >
                        <a @click="editRegister(value)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                          data-toggle="tooltip" data-original-title="Editar registro">
                          <i class="fa fa-pencil-alt"></i>
                        </a>

                        <a @click="deleteRegister(value.id)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip" data-original-title="Eliminar registro">
                          <i class="fa fa-trash"></i>
                        </a>
                      </td>
                    </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="isQuoteMode && serviceOrderServices.length">
          <div class="card-header pb-0">
            <p class="text-uppercase mb-0">Servicios de la orden (opcionales)</p>
          </div>
          <div class="card-body">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Servicio</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="service in serviceOrderServices" :key="service.id">
                    <td class="text-sm">{{ service.name }}</td>
                    <td class="text-center text-sm">{{ formatMoney(service.price) }}</td>
                  </tr>
                  <tr>
                    <td class="text-end text-sm font-weight-bold">Total servicios</td>
                    <td class="text-center text-sm font-weight-bold">{{ formatMoney(servicesTotal) }}</td>
                  </tr>
                  <tr>
                    <td class="text-end text-sm font-weight-bold">Total con servicios</td>
                    <td class="text-center text-sm font-weight-bold">{{ formatMoney(saleTotal + servicesTotal) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card mt-3" v-if="form.id != 0">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0">Modo de pago</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="addPayment"
              >
                Agregar pago
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Forma de pago</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Valor pagado</th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      v-if="(user.role !== '1' && form.status === 0) || user.role === '1'"
                    >
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="payment in paymentsData" :key="payment.id">
                    <td class="align-middle text-center text-sm">
                      {{ payment.payment_method }}
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatMoney(payment.amount_pagado) }}
                      </span>
                    </td>
                    <td
                      class="align-middle text-center"
                      v-if="(user.role !== '1' && form.status === 0) || user.role === '1'"
                    >
                      <a
                        @click="editPayment(payment)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                      >
                        <i class="fa fa-pencil-alt"></i>
                      </a>
                      <a
                        @click="deletePayment(payment.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!paymentsData.length">
                    <td colspan="3" class="text-center text-muted text-sm py-4">
                      No hay pagos registrados.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mt-3 g-3">
              <div class="col-md-4">
                <div class="payment-summary-card">
                  <p class="text-sm mb-0 text-secondary">Total venta</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(saleTotal) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="payment-summary-card">
                  <p class="text-sm mb-0 text-secondary">Total pagado</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(totalPagado) }}</p>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="payment-summary-card"
                  :class="diferenciaPendiente <= 0 ? 'payment-summary-card--paid' : 'payment-summary-card--pending'"
                >
                  <p class="text-sm mb-0 text-secondary">Diferencia pendiente</p>
                  <p class="text-sm font-weight-bold mb-0">{{ formatMoney(diferenciaPendiente) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar pago -->
    <div class="modal fade" id="ModalPayment" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="paymentModalLabel">{{ paymentModal.id ? 'Editar pago' : 'Agregar pago' }}</h5>
            <button type="button" class="btn-close" @click="closePaymentModal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label class="form-label">Forma de pago</label>
                <select v-model="paymentModal.payment_method" class="form-select">
                  <option value="">Seleccione forma de pago</option>
                  <option v-for="method in paymentMethods" :key="method" :value="method">
                    {{ method }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Valor pagado</label>
                <input
                  type="text"
                  inputmode="decimal"
                  v-model="formattedPaymentPagado"
                  class="form-control"
                  placeholder="0,00"
                >
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closePaymentModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitPayment">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar detalles de Pedido -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar producto</h5>
            <button type="button" class="btn-close" @click="submitForm"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Producto</label>
                <select ref="ProductionSelect" class="form-select select2" style="width:100%;">
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="modal.quantity" id="total_price" class="form-control"
                  placeholder="Ingrese el valor total">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Precio Unidad</label>
                <input
                  type="text"
                  inputmode="decimal"
                  v-model="formattedPrice"
                  id="modal_unit_price"
                  class="form-control"
                  placeholder="0,00"
                >
              </div>
              <div class="mb-3">
                <label for="amount" class="form-label">Total</label>
                <input
                  type="text"
                  inputmode="decimal"
                  v-model="totalPrice"
                  id="modal_total_price"
                  class="form-control"
                  placeholder="0,00"
                >
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Agregar Cliente -->
  <div class="modal fade" id="ModalAddClient" tabindex="-1" aria-labelledby="addClientModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="addClientModalLabel">Agregar Cliente</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="client-name" class="form-label">Nombre *</label>
              <input type="text" v-model="newClient.name" id="client-name" class="form-control" placeholder="Ingrese el nombre" required>
            </div>
            <div class="mb-3">
              <label for="client-document-type" class="form-label">Tipo de Documento</label>
              <select id="client-document-type" class="form-control" v-model="newClient.document_type">
                <option value="">Seleccione un tipo de documento</option>
                <option value="CC">Cédula de Ciudadanía (CC)</option>
                <option value="CE">Cédula de Extranjería (CE)</option>
                <option value="TI">Tarjeta de Identidad (TI)</option>
                <option value="RC">Registro Civil (RC)</option>
                <option value="PA">Pasaporte (PA)</option>
                <option value="PEP">Permiso Especial de Permanencia (PEP)</option>
                <option value="NIT">Número de Identificación Tributaria (NIT)</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="client-document" class="form-label">Número de Documento</label>
              <input type="text" v-model="newClient.document" id="client-document" class="form-control" placeholder="Opcional">
            </div>
            <div class="mb-3">
              <label for="client-email" class="form-label">Email</label>
              <input type="email" v-model="newClient.email" id="client-email" class="form-control" placeholder="Opcional">
            </div>
            <div class="mb-3">
              <label for="client-phone" class="form-label">Teléfono</label>
              <input type="text" v-model="newClient.phone" id="client-phone" class="form-control" placeholder="Opcional">
            </div>
            <div class="mb-3">
              <label for="client-address" class="form-label">Dirección</label>
              <input type="text" v-model="newClient.address" id="client-address" class="form-control" placeholder="Opcional">
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <div class="form-check form-switch mt-4">
                  <input
                    id="client-oil-reminder-enabled"
                    v-model="newClient.oil_reminder_enabled"
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                  />
                  <label class="form-check-label" for="client-oil-reminder-enabled">
                    Recordatorio de cambio de aceite
                  </label>
                </div>
              </div>
              <div class="col-6">
                <label for="client-oil-reminder-days" class="form-label">Recordatorio cada (días)</label>
                <input
                  id="client-oil-reminder-days"
                  v-model="newClient.oil_reminder_days"
                  type="number"
                  min="1"
                  max="365"
                  class="form-control"
                  :disabled="!newClient.oil_reminder_enabled"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeAddClientModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="saveClient">Guardar</button>
        </div>
      </div>
    </div>
  </div>



</template>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';
import userService from '../../../services/user.service';
import { sharePublicDocument } from '../../../helpers/whatsapp';
import { formatCurrencyInput, parseCurrencyInput } from '../../../helpers/currencyInput';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Remissions Create",
  data() {
    return {
      showMenu: false,
      modalBudget: null,
      modalPayment: null,
      apiUrl: process.env.VUE_APP_API_IMAGE_URL || process.env.VUE_APP_API_BASE_URL,
      paymentPhotos: [],
      uploadingPaymentPhoto: false,
      isFinish: false,
      filter: {
        production_id: [],
        model_id: [],
        oficio_id: [],
        user_id: [],
      },
      models: [],
      user: {},
      form: {
        id: 0,
        cliente_id: '',
        name: '',
        document_type: '',
        document: '',
        address: '',
        phone: '',
        email: '',
        observation: '',
        service_order_id: '',
        status: 0,
        type: 'sale',
      },
      data: {},
      detailsList: [],
      productions: [],
      paymentsData: [],
      paymentMethods: [
        'NEQUI',
        'DAVIPLATA',
        'DATAFONO',
        'EFECTIVO',
        'CREDITO',
        'TRANSFERENCIA',
      ],
      paymentModal: {
        id: 0,
        remission_id: 0,
        payment_method: '',
        amount_pagado: 0,
      },
      modal: {
        id: 0,
        remission_id: 0,
        production_id: 0,
        model_id: 0,
        quantity: 1,
        price: 0,
        total: 0
      },
      modalEvidencia: [],
      suppliers: [],
      filteredSuppliers: [],
      clients: [],
      serviceOrders: [],
      selectedServiceOrder: null,
      serviceOrderServices: [],
      modalAddClient: null,
      newClient: {
        name: '',
        email: '',
        phone: '',
        document: '',
        document_type: '',
        address: '',
        role: '4', // Cliente
        status: 1,
        payment: '0',
        oil_reminder_enabled: false,
        oil_reminder_days: 30,
      },
    };
  },
  components: { ArgonButton, ArgonTextarea },
  computed: {
    isQuoteMode() {
      return this.form.type === 'quote';
    },
    pageTitle() {
      return this.isQuoteMode ? 'Crear cotización' : 'Crear venta';
    },
    formattedPrice: {
      get() {
        return formatCurrencyInput(this.modal.price);
      },
      set(value) {
        this.modal.price = parseCurrencyInput(value);
        this.updateModalTotal();
      },
    },
    totalPrice: {
      get() {
        return formatCurrencyInput(this.modal.total);
      },
      set(value) {
        this.modal.total = parseCurrencyInput(value);
        const qty = parseFloat(this.modal.quantity) || 0;
        if (qty > 0) {
          this.modal.price = Math.round((this.modal.total / qty) * 100) / 100;
        }
      },
    },
    formattedPaymentPagado: {
      get() {
        return formatCurrencyInput(this.paymentModal.amount_pagado);
      },
      set(value) {
        this.paymentModal.amount_pagado = parseCurrencyInput(value);
      },
    },
    detailsTableColspan() {
      const showOptions =
        this.form.status != 1 &&
        ((this.user.role !== '1' && this.form.status === 0) || this.user.role === '1');
      return showOptions ? 5 : 4;
    },
    servicesTotal() {
      return this.serviceOrderServices.reduce((sum, s) => sum + (parseFloat(s.price) || 0), 0);
    },
    saleTotal() {
      return this.detailsList.reduce((sum, item) => sum + parseFloat(item.total ?? 0), 0);
    },
    totalPagado() {
      return this.paymentsData.reduce((sum, payment) => sum + parseFloat(payment.amount_pagado ?? 0), 0);
    },
    diferenciaPendiente() {
      return Math.max(0, this.saleTotal - this.totalPagado);
    },
  },
  watch: {
    '$route.query.id': {
      async handler(newId, oldId) {
        if (newId === oldId) return;
        const remissionId = this.resolveRemissionIdFromRoute();
        if (remissionId && remissionId !== this.form.id) {
          await this.loadRemission(remissionId);
        }
      },
    },
    "modal.quantity"() {
      this.updateModalTotal();
    },
  },
  methods: {
    updateModalTotal() {
      const qty = parseFloat(this.modal.quantity) || 0;
      const price = parseFloat(this.modal.price) || 0;
      this.modal.total = Math.round(price * qty * 100) / 100;
    },
    formatMoney(value) {
      return parseFloat(value ?? 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    generateRandomClientEmail() {
      const randomHash = Math.random().toString(36).slice(2, 10);
      return `cliente+${randomHash}@mistock.co`;
    },
    async getClients(){
      try {
        const response = await userService.getAll('all');
        const allUsers = response.data.data || response.data || [];
        // Filtrar solo clientes (role === '4')
        this.clients = allUsers.filter(user => user.role === '4');
        this.$nextTick(() => {
          this.initClientSelect2();
        });
      } catch (error) {
        console.error('Error fetching clients:', error);
      }
    },
    initClientSelect2() {
      if (!this.$refs.clientSelect) return;
      const select = $(this.$refs.clientSelect);
      if (select.hasClass("select2-hidden-accessible")) {
        select.select2("destroy");
      }
      select.off("change");
      select.select2({
        placeholder: "Seleccione un cliente",
        allowClear: true,
        width: "100%",
        containerCssClass: "remissions-client-select2-container",
      });
      select.on("change", (e) => {
        this.form.cliente_id = e.target.value;
        this.selectClient();
      });
      if (this.form.cliente_id) {
        select.val(String(this.form.cliente_id)).trigger("change");
      }
    },
    formatServiceOrderLabel(order) {
      if (!order) return '';
      const num = String(order.id).padStart(4, '0');
      const name = order.customer_name || order.client?.name || '';
      const plate = order.license_plate ? ` - ${order.license_plate}` : '';
      return `OS #${num} - ${name}${plate}`;
    },
    async loadServiceOrdersForClient(autoSelectLatest = false) {
      if (!this.isQuoteMode) {
        return;
      }

      if (!this.form.cliente_id) {
        this.serviceOrders = [];
        this.form.service_order_id = '';
        this.selectedServiceOrder = null;
        this.$nextTick(() => this.initServiceOrderSelect2());
        return;
      }

      try {
        await this.$store.dispatch('serviceOrders/fetchData', {
          page: 'all',
          client_id: this.form.cliente_id,
        });
        const orders = this.$store.state.serviceOrders?.data || [];
        this.serviceOrders = Array.isArray(orders) ? [...orders] : [];

        const preserveId = this.form.service_order_id;
        if (autoSelectLatest && this.serviceOrders.length && !preserveId) {
          this.form.service_order_id = this.serviceOrders[0].id;
        } else if (preserveId && !this.serviceOrders.some((o) => String(o.id) === String(preserveId))) {
          try {
            const one = await this.$store.dispatch('serviceOrders/getData', preserveId);
            if (one?.data) {
              this.serviceOrders.unshift(one.data);
            }
          } catch (e) {
            console.warn('Orden de servicio vinculada no encontrada en listado del cliente', e);
          }
        }

        this.applySelectedServiceOrder();
        this.$nextTick(() => this.initServiceOrderSelect2());
      } catch (error) {
        console.error('Error loading service orders:', error);
        this.serviceOrders = [];
        this.$nextTick(() => this.initServiceOrderSelect2());
      }
    },
    applySelectedServiceOrder() {
      if (!this.form.service_order_id) {
        this.selectedServiceOrder = null;
        this.serviceOrderServices = [];
        return;
      }
      this.selectedServiceOrder =
        this.serviceOrders.find((o) => String(o.id) === String(this.form.service_order_id)) || null;
      this.loadServiceOrderServices(this.form.service_order_id);
    },
    async loadServiceOrderServices(orderId) {
      // El listado de órdenes no trae los servicios: se consultan del detalle
      try {
        const response = await this.$store.dispatch('serviceOrders/getData', orderId);
        if (String(this.form.service_order_id) !== String(orderId)) return;
        this.serviceOrderServices = Array.isArray(response?.data?.services) ? response.data.services : [];
      } catch (error) {
        console.error('Error loading service order services:', error);
        this.serviceOrderServices = [];
      }
    },
    initServiceOrderSelect2() {
      if (!this.isQuoteMode || !this.$refs.serviceOrderSelect) {
        return;
      }

      const select = $(this.$refs.serviceOrderSelect);
      if (select.hasClass('select2-hidden-accessible')) {
        select.select2('destroy');
      }
      select.off('change');

      select.select2({
        placeholder: this.form.cliente_id
          ? 'Seleccione orden de servicio (opcional)'
          : 'Seleccione un cliente primero',
        allowClear: true,
        width: '100%',
        containerCssClass: 'remissions-service-order-select2-container',
        matcher: (params, data) => {
          if ($.trim(params.term) === '') {
            return data;
          }
          if (!data.id) {
            return null;
          }
          const term = params.term.toLowerCase();
          const text = (data.text || '').toLowerCase();
          return text.includes(term) ? data : null;
        },
      });

      select.on('change', () => {
        this.form.service_order_id = select.val() || '';
        this.applySelectedServiceOrder();
      });

      const value = this.form.service_order_id ? String(this.form.service_order_id) : '';
      select.val(value).trigger('change.select2');
    },
    syncClientFieldsFromId() {
      const selectedClient = this.clients.find(c => c.id == this.form.cliente_id);
      if (selectedClient) {
        this.form.name = selectedClient.name;
        this.form.email = selectedClient.email || '';
        this.form.phone = selectedClient.phone || '';
        this.form.document = selectedClient.document || '';
        this.form.document_type = selectedClient.document_type || '';
        this.form.address = selectedClient.address || '';
      }
    },
    selectClient() {
      this.syncClientFieldsFromId();

      if (this.isQuoteMode) {
        this.form.service_order_id = '';
        this.selectedServiceOrder = null;
        this.loadServiceOrdersForClient(true);
      }
    },
    openAddClientModal() {
      const modalElement = document.getElementById('ModalAddClient');
      this.modalAddClient = new Modal(modalElement);
      this.modalAddClient.show();
    },
    closeAddClientModal() {
      if (this.modalAddClient) {
        this.modalAddClient.hide();
      }
      // Resetear formulario
      this.newClient = {
        name: '',
        email: '',
        phone: '',
        document: '',
        document_type: '',
        address: '',
        role: '4',
        status: 1,
        payment: '0',
        oil_reminder_enabled: false,
        oil_reminder_days: 30,
      };
    },
    async saveClient() {
      try {
        if (!this.newClient.name?.trim()) {
          Swal.fire('Error', 'El nombre del cliente es obligatorio', 'error');
          return;
        }

        const clientData = {
          ...this.newClient,
          oil_reminder_enabled: Boolean(this.newClient.oil_reminder_enabled),
          oil_reminder_days: this.newClient.oil_reminder_enabled
            ? (parseInt(this.newClient.oil_reminder_days, 10) || 30)
            : 30,
          name: this.newClient.name.trim(),
          email: this.newClient.email?.trim() || '',
          phone: this.newClient.phone?.trim() || '',
          document: this.newClient.document?.trim() || '',
          document_type: this.newClient.document_type || '',
          address: this.newClient.address?.trim() || '',
        };

        const response = await userService.createUser(clientData);
        
        if (response && response.status >= 200 && response.status < 300) {
          Swal.fire('Éxito', 'Cliente creado correctamente', 'success');
          this.closeAddClientModal();
          // Recargar lista de clientes
          await this.getClients();
          // Seleccionar el cliente recién creado
          this.form.cliente_id = response.data.id;
          this.$nextTick(() => {
            if (this.$refs.clientSelect) {
              $(this.$refs.clientSelect).val(String(this.form.cliente_id)).trigger("change");
            }
          });
          this.selectClient();
        } else {
          throw new Error(response?.data?.message || 'Error al crear el cliente');
        }
      } catch (error) {
        console.error('Error creating client:', error);
        const errorMsg = error.response?.data?.message || error.message || 'Error al crear el cliente';
        Swal.fire('Error', errorMsg, 'error');
      }
    },
    async getProductions() {
      this.productions = await this.$store.dispatch('inventory/getAll', { status: 1 });

      this.$nextTick(async () => {

        const select = $(this.$refs.ProductionSelect);

        // Destruir select2 si ya está inicializado
        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }

        select.empty();

        select.append('<option value="" disabled selected>Seleccionar producto</option>');
        this.productions.forEach(prod => {
          select.append(new Option(this.formatProductOption(prod), prod.id, false, false));
        });

        $(this.$refs.ProductionSelect).select2({
          placeholder: 'Seleccionar producto',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ProductionSelect).on('change', async () => {
          this.modal.production_id = $(this.$refs.ProductionSelect).val();

          const selectedModel = this.productions.find(prod => prod.id == this.modal.production_id);
          if (selectedModel) {

            this.modal.price = parseFloat(selectedModel.sale_price) || 0;
            this.updateModalTotal();
          }

          //await this.getModels();
        })
      });
    },
    async getModels() {
      this.models = await this.$store.dispatch('productionModels/getData', this.modal.production_id);

      this.$nextTick(() => {
        const select = $(this.$refs.ModelSelect);

        if (select.hasClass("select2-hidden-accessible")) {
          select.select2('destroy');
        }
        select.empty();
        select.append('<option value="" disabled selected>Seleccionar referencia</option>');
        this.models.data.forEach(prod => {
          select.append(new Option(`#${prod.model.id} - ${prod.model.name} (${prod.model.ref}) - TALLA: ${prod.size.size} - COLOR: ${prod.size.color.name} `, prod.model.id, false, false));
        });

        $(this.$refs.ModelSelect).select2({
          placeholder: 'Seleccione una referencia',
          allowClear: false,
          dropdownParent: $('#ModalBudget .modal-body')
        });

        $(this.$refs.ModelSelect).on('change', () => {
          this.modal.model_id = $(this.$refs.ModelSelect).val();

          const selectedModel = this.models.data.find(prod => prod.model.id == this.modal.model_id);
          if (selectedModel) {

            this.modal.price = parseFloat(selectedModel.model.price);

            if (this.modal.id == 0) {
              this.modal.quantity = selectedModel.quantity_to_produce;
            }

            this.updateModalTotal();
          }
        });
      });
    },
    addDetail() {
      this.modal.id = 0;
      this.modal.production_id = 0;
      this.modal.model_id = 0;
      this.modal.quantity = 1;
      this.modal.price = 0;
      this.modal.total = 0;

      this.getProductions();

      this.openModal();
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    formatProductOption(prod) {
      const ref = (prod?.ref || '').trim() || 'Sin ref';
      const name = (prod?.name || '').trim() || 'Sin nombre';
      const price = formatCurrencyInput(parseFloat(prod?.sale_price) || 0);
      return `${ref}-${name}-$${price}`;
    },
    formatDetailProductLabel(detail) {
      const ref = (detail?.produccion?.ref || '').trim();
      const name = (detail?.produccion?.name || '').trim();
      if (!ref && !name) return 'No encontrado';
      if (!ref) return name;
      if (!name) return ref;
      return `${ref} - ${name}`;
    },
    parseDetailsResponse(response) {
      const body = response?.data;
      if (Array.isArray(body)) return body;
      if (Array.isArray(body?.data)) return body.data;
      return [];
    },
    async getData() {
      if (!this.form.id) {
        this.detailsList = [];
        return;
      }
      try {
        const response = await this.$store.dispatch('remissionsDetails/getData', this.form.id);
        this.detailsList = this.parseDetailsResponse(response);
      } catch (error) {
        console.error('Error fetching remission details:', error);
        this.detailsList = [];
      }
    },
    syncRemissionQueryInUrl() {
      if (!this.form.id) return;
      const nextQuery = { ...this.$route.query, id: String(this.form.id) };
      if (String(this.$route.query.id || '') === String(this.form.id)) return;
      try {
        this.$router.replace({ path: '/remissions/create', query: nextQuery });
      } catch (error) {
        console.warn('No se pudo actualizar la URL de la venta:', error);
      }
    },
    resolveRemissionIdFromRoute(route = this.$route) {
      const fromQuery = route.query?.id;
      if (fromQuery != null && fromQuery !== '') {
        const parsed = Number(fromQuery);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
      }
      const fromParams = route.params?.id;
      if (fromParams != null && fromParams !== '') {
        const parsed = Number(fromParams);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
      }
      return null;
    },
    async loadRemissionFromRoute() {
      const remissionId = this.resolveRemissionIdFromRoute();
      if (remissionId) {
        await this.loadRemission(remissionId);
        return;
      }
      if (this.$route.params?.data) {
        try {
          const params = JSON.parse(this.$route.params.data);
          if (params?.id) {
            await this.loadRemission(params.id);
          }
        } catch (error) {
          console.error('Error al parsear los datos del registro:', error);
        }
      }
    },
    async loadRemission(id) {
      try {
        const response = await this.$store.dispatch('remissions/getData', id);
        const params = response?.data;
        if (!params?.id) return;

        this.form.id = params.id;
        this.form.cliente_id = params.cliente_id ? parseInt(params.cliente_id, 10) : '';
        this.form.name = params.name || '';
        this.form.document_type = params.document_type || '';
        this.form.document = params.document || '';
        this.form.address = params.address || '';
        this.form.phone = params.phone || '';
        this.form.email = params.email || '';
        this.form.type = params.type || 'sale';
        this.form.observation = params.observation || '';
        this.form.service_order_id = params.service_order_id || '';
        this.form.status = params.status ?? 0;
        this.modal.remission_id = params.id;

        await this.getProductions();

        this.$nextTick(async () => {
          if (this.form.cliente_id && this.$refs.clientSelect) {
            $(this.$refs.clientSelect).val(String(this.form.cliente_id)).trigger('change.select2');
          }
          this.syncClientFieldsFromId();
          if (this.isQuoteMode) {
            await this.loadServiceOrdersForClient(false);
          }
        });

        await this.getData();
        await this.getPayments();
        await this.getPaymentPhotos();
      } catch (error) {
        console.error('Error loading remission:', error);
        Swal.fire('Error', 'No se pudo cargar la venta.', 'error');
      }
    },
    async getPayments() {
      try {
        const response = await this.$store.dispatch('remissionsPayments/getData', this.form.id);
        this.paymentsData = response.data || [];
      } catch (error) {
        console.error('Error fetching payments:', error);
        this.paymentsData = [];
      }
    },
    async getPaymentPhotos() {
      if (!this.form.id) {
        this.paymentPhotos = [];
        return;
      }

      try {
        const response = await this.$store.dispatch('media/getData', this.form.id);
        this.paymentPhotos = (response.data || []).filter(
          (item) => item.mediaable_type === 'remission_payment_photos'
        );
      } catch (error) {
        console.error('Error fetching payment photos:', error);
        this.paymentPhotos = [];
      }
    },
    openPaymentPhoto(photo) {
      const url = this.apiUrl + photo.file_path;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    async onPaymentPhotoChange(event) {
      const fileInput = event?.target || this.$refs.paymentPhotoInput;
      const files = Array.from(fileInput?.files || []);
      if (!files.length) return;

      if (!this.form.id) {
        Swal.fire('Advertencia', 'Debe guardar la venta antes de adjuntar fotos.', 'warning');
        if (fileInput) fileInput.value = '';
        return;
      }

      this.uploadingPaymentPhoto = true;
      try {
        for (const file of files) {
          const formData = new FormData();
          formData.append('mediaable_id', this.form.id);
          formData.append('mediaable_type', 'remission_payment_photos');
          formData.append('file', file);

          const response = await this.$store.dispatch('media/save', formData);
          if (!response || response.status < 200 || response.status >= 300) {
            throw new Error(response?.data?.message || 'Error al subir la foto');
          }
        }

        await this.getPaymentPhotos();
        Swal.fire('Éxito', 'Foto(s) de pago adjuntada(s) correctamente.', 'success');
      } catch (error) {
        console.error('Error uploading payment photo:', error);
        Swal.fire(
          'Error',
          error?.response?.data?.message || error.message || 'Error al subir la foto',
          'error'
        );
      } finally {
        this.uploadingPaymentPhoto = false;
        if (fileInput) fileInput.value = '';
      }
    },
    async removePaymentPhoto(photoId) {
      try {
        const result = await Swal.fire({
          title: '¿Eliminar foto?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar',
        });

        if (!result.isConfirmed) return;

        const response = await this.$store.dispatch('media/delete', photoId);
        if (response && response.status >= 200 && response.status < 300) {
          await this.getPaymentPhotos();
          Swal.fire('Eliminado', 'La foto fue eliminada correctamente.', 'success');
        } else {
          throw new Error(response?.data?.message || 'Error al eliminar la foto');
        }
      } catch (error) {
        console.error('Error deleting payment photo:', error);
        Swal.fire(
          'Error',
          error?.response?.data?.message || error.message || 'Error al eliminar la foto',
          'error'
        );
      }
    },
    resetPaymentModal() {
      this.paymentModal = {
        id: 0,
        remission_id: this.form.id,
        payment_method: '',
        amount_pagado: 0,
      };
    },
    addPayment() {
      this.resetPaymentModal();
      this.openPaymentModal();
    },
    editPayment(payment) {
      this.paymentModal = {
        id: payment.id,
        remission_id: payment.remission_id,
        payment_method: payment.payment_method,
        amount_pagado: parseFloat(payment.amount_pagado ?? 0),
      };
      this.openPaymentModal();
    },
    openPaymentModal() {
      const modalElement = document.getElementById('ModalPayment');
      this.modalPayment = new Modal(modalElement);
      this.modalPayment.show();
    },
    closePaymentModal() {
      if (this.modalPayment) {
        this.modalPayment.hide();
      }
      this.resetPaymentModal();
    },
    async submitPayment() {
      try {
        if (!this.paymentModal.payment_method) {
          Swal.fire('Error', 'Seleccione una forma de pago', 'error');
          return;
        }

        if (this.paymentModal.amount_pagado <= 0) {
          Swal.fire('Error', 'Ingrese el valor pagado', 'error');
          return;
        }

        this.paymentModal.remission_id = this.form.id;
        const response = await this.$store.dispatch('remissionsPayments/save', this.paymentModal);

        if (response && response.status >= 200 && response.status < 300) {
          await this.getPayments();
          this.closePaymentModal();

          const formalized = await this.tryAutoFormalize();
          if (!formalized) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El pago ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            });
          }
        } else {
          throw new Error(response?.data?.message || 'Error al guardar el pago');
        }
      } catch (error) {
        console.error('Error al guardar el pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el pago',
        });
      }
    },
    async deletePayment(paymentId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch('remissionsPayments/delete', paymentId);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire('Eliminado!', 'El pago ha sido eliminado correctamente.', 'success');
            this.getPayments();
          } else {
            throw new Error(response?.data?.message || 'Error al eliminar el pago');
          }
        }
      } catch (error) {
        console.error('Error al eliminar el pago:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el pago',
        });
      }
    },
    async tryAutoFormalize() {
      if (this.form.status == 1 || !this.form.id || this.saleTotal <= 0 || this.diferenciaPendiente > 0) {
        return false;
      }

      this.form.status = 1;
      const saved = await this.save();
      if (!saved) {
        this.form.status = 0;
      }
      return saved;
    },
    async sharePublicPdf() {
      if (!this.form.id) {
        Swal.fire('Advertencia', 'Debe guardar la venta antes de compartir el PDF.', 'warning');
        return;
      }

      try {
        const response = await this.$store.dispatch('remissions/getPublicPdfLink', this.form.id);
        const publicUrl = response?.data?.url;
        if (!publicUrl) throw new Error('No se recibió URL pública');

        const settingsRes = await this.$store.dispatch('settings/get');
        const companyName = settingsRes?.data?.company_name || this.$store.state.settings?.data?.company_name || '';
        const invoiceNo = `F${String(this.form.id).padStart(7, '0')}`;

        await sharePublicDocument({
          phone: this.form.phone,
          companyName,
          detailText: `le comparto su factura ${invoiceNo}:\n${publicUrl}`,
          shareTitle: `Factura ${invoiceNo}`,
          publicUrl,
          Swal,
        });
      } catch (error) {
        console.error('Error al compartir PDF:', error);
        const msg = error?.data?.message || error?.response?.data?.message || 'No se pudo generar el enlace público.';
        Swal.fire('Error', msg, 'error');
      }
    },
    async generatePdf() {
      if (!this.form.id) {
        Swal.fire('Advertencia', 'Debe guardar la venta antes de generar el PDF.', 'warning');
        return;
      }

      try {
        const response = await this.$store.dispatch('remissions/getDoc', this.form.id);
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Factura_${String(this.form.id).padStart(4, '0')}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al generar PDF:', error);
        const msg = error?.response?.data?.message || 'No se pudo generar el PDF.';
        Swal.fire('Error', msg, 'error');
      }
    },
    async save() {
      try {
        // Validar que se haya seleccionado un cliente
        if (!this.form.cliente_id) {
          Swal.fire('Error', 'Por favor seleccione un cliente', 'error');
          return false;
        }

        // Obtener el usuario actual para user_id
        const currentUser = JSON.parse(localStorage.getItem('user'));
        if (!currentUser || !currentUser.id) {
          Swal.fire('Error', 'No se pudo obtener la información del usuario', 'error');
          return false;
        }

        // Preparar datos para guardar
        const remissionData = {
          id: this.form.id || 0,
          user_id: currentUser.id,
          cliente_id: this.form.cliente_id,
          service_order_id: this.isQuoteMode && this.form.service_order_id
            ? this.form.service_order_id
            : null,
          observation: this.form.observation || '',
          type: this.form.type || 'sale',
          status: this.form.status || 0,
        };

        // Dispara la acción de Vuex para guardar
        const response = await this.$store.dispatch("remissions/save", remissionData);
        if (response && response.status >= 200 && response.status < 300) {
          const message = this.form.status == 1 
            ? 'La venta ha sido formalizada correctamente. Las cantidades se han restado del inventario.'
            : 'El registro ha sido guardado correctamente. Ahora puede agregar los productos.';
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: message,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.form.id = response.data.id;
              this.form.status = response.data.status ?? this.form.status;
              this.modal.remission_id = this.form.id;
              this.syncRemissionQueryInUrl();
              await this.getProductions();
              await this.getData();
              await this.getPayments();
              await this.getPaymentPhotos();
            }
          });

          return true;
        }

        throw new Error(response.data.message || 'Error al guardar la venta');

      } catch (error) {
        console.error("Error al crear la venta:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar la venta',
        });
        return false;
      }
    },
    async submitForm() {
      try {
        // Dispara la acción de Vuex para guardar el modal
        this.modal.remission_id =   this.form.id;
        const response = await this.$store.dispatch("remissionsDetails/save", this.modal);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.modal.id = 0;
              this.modal.production_id = 0;
              this.modal.model_id = 0;
              this.modal.quantity = 1;
              this.modal.price = 0;
              this.modal.total = 0;

              $(this.$refs.processesSelect).val('').trigger('change');

              this.getData();
              this.closeModal();
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async editRegister(params) {
      this.modal.id = params.id;
      this.modal.remission_id = this.form.id;
      this.modal.production_id = params.production_id;
      this.modal.model_id = params.model_id || 0;
      this.modal.quantity = params.quantity;
      this.modal.price = parseFloat(params.price) || 0;
      this.modal.total = parseFloat(params.total) || 0;

      await this.getProductions();
      this.openModal();

      this.$nextTick(() => {
        if (this.$refs.ProductionSelect) {
          $(this.$refs.ProductionSelect)
            .val(String(params.production_id))
            .trigger('change');
        }
      });
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissionsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
  },
  async mounted() {

    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.$route.query?.type === 'quote') {
      this.form.type = 'quote';
    }

    // Cargar clientes primero para que estén disponibles al cargar la venta
    await this.getClients();
    this.$nextTick(() => {
      this.initClientSelect2();
    });

    await this.loadRemissionFromRoute();
    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    if (this.$refs.clientSelect) {
      const select = $(this.$refs.clientSelect);
      if (select.hasClass("select2-hidden-accessible")) {
        select.select2("destroy");
      }
    }
    if (this.$refs.serviceOrderSelect) {
      const soSelect = $(this.$refs.serviceOrderSelect);
      if (soSelect.hasClass('select2-hidden-accessible')) {
        soSelect.select2('destroy');
      }
    }
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style scoped>
.remissions-create-page :deep(.remissions-client-select2-container) {
  width: 100% !important;
}

.remissions-create-page :deep(.remissions-client-select2-container .select2-selection--single) {
  height: 31.5px !important;
  border: 1px solid #d2d6da !important;
  border-radius: 0.375rem !important;
}

.remissions-create-page :deep(.remissions-client-select2-container .select2-selection--single .select2-selection__rendered) {
  line-height: 29.5px !important;
  padding-left: 0.5rem !important;
  padding-right: 20px !important;
}

.remissions-create-page :deep(.remissions-client-select2-container .select2-selection--single .select2-selection__arrow) {
  height: 29.5px !important;
  right: 8px !important;
  top: 1px !important;
}

.remissions-create-page :deep(.remissions-service-order-select2-container) {
  width: 100% !important;
}

.remissions-create-page :deep(.remissions-service-order-select2-container .select2-selection--single) {
  height: 31.5px !important;
  border: 1px solid #d2d6da !important;
  border-radius: 0.375rem !important;
}

.remissions-create-page :deep(.remissions-service-order-select2-container .select2-selection--single .select2-selection__rendered) {
  line-height: 29.5px !important;
  padding-left: 0.5rem !important;
}

.service-order-description {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  max-height: 220px;
  overflow-y: auto;
}

.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

.payment-summary-card {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  background: #fff;
  height: 100%;
}

.payment-summary-card--pending {
  border-color: #f5365c;
  background: #fff5f7;
}

.payment-summary-card--paid {
  border-color: #2dce89;
  background: #f0fff8;
}

.payment-photo-card {
  width: 100%;
  max-width: 120px;
  height: 120px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.payment-photo-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  cursor: pointer;
}

.detail-product-label {
  max-width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  margin: 0 auto;
}

.payment-photo-remove-btn {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: #ef476f;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 0;
}
</style>
